module.exports = __webpack_public_path__ + "static/media/light-rail-tag-icon.3c97efe5.svg";